export const APP_NAME = "Nucleo";
